module.exports = __webpack_public_path__ + "img/airplane-2.87dac654.jpg";